import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { deletejob, getJobs, postJob } from "./jobsAPI";

const initialState = {
  isLoading: false,
  jobs: [],
  error: "",
};

export const fetchJobs = createAsyncThunk("jobs/fetchJobs", async () => {
  const jobs = await getJobs();
  return jobs;
});

export const addJob = createAsyncThunk("jobs/addJob", async (data) => {
  const jobs = await postJob(data);
  return jobs;
});

export const removeJob = createAsyncThunk("jobs/removeJob", async (id) => {
  const jobs = await deletejob(id);
  return jobs;
});

export const jobsSlice = createSlice({
  name: "jobs",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchJobs.pending, (state) => {
        state.isLoading = true;
        state.jobs = [];
        state.error = "";
      })
      .addCase(fetchJobs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
        state.error = "";
      })
      .addCase(fetchJobs.rejected, (state, action) => {
        state.isLoading = false;
        state.jobs = [];
        state.error = action.error?.message;
      });
    builder
      .addCase(addJob.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(addJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.jobs = action.payload;
        state.error = "";
      })
      .addCase(addJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message;
      })
      .addCase(removeJob.pending, (state) => {
        state.isLoading = true;
        state.error = "";
      })
      .addCase(removeJob.fulfilled, (state, action) => {
        state.isLoading = false;
        state.error = "";
        state.jobs = state.jobs.filter((job) => {
          return job.id !== action.meta.arg;
        });
      })
      .addCase(removeJob.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.error?.message;
      });
  },
});

export default jobsSlice.reducer;
